import $ from 'jquery';
import BaseView from 'picnic/core/views/Base';


const
	CLASS_ACTIVE = 'is-active',
	SELECTOR_TILE = '.tile'
;


class View extends BaseView {

	events() {
		return {
			'click button': this._onClick
		};
	}

	_onClick(e) {
		$(e.currentTarget).closest(SELECTOR_TILE).toggleClass(CLASS_ACTIVE);
	}
}

export default View;
